import React from 'react';
import PropTypes from 'prop-types';

const ListCheckIcon = ({ className = '', ...props }) => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path d="M20 6L3 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10 11L3 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10 16H3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M14 13.5L16.1 16L20 11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ListCheckIcon.propTypes = {
  className: PropTypes.string,
};

export default ListCheckIcon;
